export const ERROR_EXPIRED_TOKEN: string = 'Expired JWT Token';
export const ERROR_INSUFFICIENT_FUNDS: string = 'Not enough points';
export const ERROR_INVALID_TOKEN: string = 'Invalid JWT Token';
export const ERROR_GENERIC: string =
    'We are currently experiencing technical issues';
export const MAINTENANCE_MESSAGE: string =
    'We are currently undergoing maintenance, we should be back online soon.';
export const MODAL_GENERIC: string = 'MODAL_GENERIC';
export const MODAL_IN_ANOTHER_SESSION: string = 'MODAL_IN_ANOTHER_SESSION';
export const MODAL_INSUFFICIENT_POINTS: string = 'MODAL_INSUFFICIENT_POINTS';
export const MODAL_INSUFFICIENT_TOKENS: string = 'MODAL_INSUFFICIENT_TOKENS';
export const MODAL_PURCHASE_TOKEN: string = 'MODAL_PURCHASE_TOKEN';
export const MODAL_NO_OPEN_TOKEN: string = 'MODAL_NO_OPEN_TOKEN';
